export const picklistTemplateProductIntegers = [];
export const picklistTemplateProductFloats = [];
export const picklistTemplateProductIsoStrings = [];
export const picklistTemplateProductWhiteList = ['id', 'picklistTemplateId', 'productId'];
export const picklistTemplateProductOptimisticList = [
  ...picklistTemplateProductWhiteList,
  'picklistTemplate',
  'product',
];
